import axios from "../instance";

export default {
    getAll: (companyId) => {
        if (companyId) {
            return axios.api.get(`/itemGroups?companyId=${companyId}`).then((response) => response.data);
        } else {
            return axios.api.get("/itemGroups").then((response) => response.data);
        }
    },
    getOne: (id) => {
        return axios.api.get(`/itemGroups/${id}`).then((response) => response.data);
    },
    search: (body) => {
        return axios.api.post("/itemGroups/search", body).then((response) => response.data);
    },
    create: (body) => {
        return axios.api.post("/itemGroups", body).then((response) => response.data);
    },
    update: (id, body) => {
        return axios.api.put(`/itemGroups/${id}`, body).then((response) => response.data);
    },
    delete: (id) => {
        return axios.api.delete(`/itemGroups/${id}`).then((response) => response.data);
    }
};
